// extracted by mini-css-extract-plugin
export default {"recos":"m4-z","productCardOverride":"n4-z","rowHasBadge":"o4-z"};